module.exports = __webpack_public_path__ + "static/img/IMG_3942.dce5ba4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/CandyCane/IMG_3942.jpg
// module id = kRwE
// module chunks = 9